import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { defaultRowToObject } from '../../io/GoogleV2Hooks';
import { SimpleIOModal } from '../../io/VOBbased/SimpleIOModal';
import { IOType } from '../../io/types';
const PayloadParserData = (props) => {
    const { setReadings } = props;
    const setPlainObjectsInParent = (commonObjects) => {
        const validMessages = commonObjects.map(obj => {
            return JSON.parse(JSON.stringify(obj));
        });
        const sortedMessages = validMessages.sort((a, b) => {
            return a.timestamp - b.timestamp;
        });
        setReadings(sortedMessages);
    };
    const rowToObjectFunction = (columnIndexedKeys, row, rowIndex) => {
        const baseObject = defaultRowToObject(columnIndexedKeys, row, rowIndex);
        const { type, ...other } = baseObject;
        const formatted = { ...other, id: other.timestamp }; // needs to have a unique ID
        return formatted;
    };
    return (_jsx("div", { children: _jsxs(Grid, { id: 'Data', container: true, direction: 'row', size: { xs: 12 }, spacing: 2, sx: {
                justifyContent: 'flex-start',
                alignItems: 'center',
            }, children: [_jsx(Grid, { size: { xs: 3 }, children: _jsx(Typography, { variant: 'body2', component: 'p', color: 'primary', children: `1) Import Readings` }) }), _jsx(SimpleIOModal, { allowIOTypeToggle: false,
                    initialIOType: IOType.IMPORT,
                    plainObjects: [],
                    setPlainObjectsInParent,
                    rowToObjectFunction })] }) }));
};
export default PayloadParserData;
